import {Component, Element, h, Prop} from '@stencil/core';
import {translate} from "../../../utils/utils";

@Component({
  tag: 'ike-demo-alert',
  styleUrl: 'ike-demo-alert.scss',
  shadow: false,
})


export class IkeDemoAlert {

  @Element() el: HTMLElement;
  @Prop() layout: HTMLElement;

  componentDidRender(){
    const header = this.el.querySelector(".demo_alert");

    this.layout.addEventListener("scroll", () => {
      if (this.layout.scrollTop > 1) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    });
  }
  render(){
    return (<div class="demo_alert">
      <i class="icon-alert-triangle margin-right-10"></i><span>{translate("Vous etes sur une billetterie de test. Les billets commandes ne seront pas valables.")}</span>
    </div>);
  }
}
